import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";
import {usePageResize} from "@/modules/reader/book/pageResize";

class ContentRectAnnotation extends AbstractAnnotations{

    static get TYPE() {
        if (this.annotations && this.annotations["type"]) {
            return this.annotations["type"];
        }

        return null;
    }

    constructor(builder) {

        super();
        const { pageState, setCurrentPage} = usePaging();
        this.annotations.domPos = builder.domPos;
        this.annotations["isContentRect"] = true;
        const {pageResizeState}= usePageResize();

        let hasLayer;

        for (let [key,value] of Object.entries(builder.meta)) {

            if (key === "layer") {
                if ( value === "hanzi")  {
                    this.annotations["type"] =  "hanzi";
                    this.annotations["isHanPin"] = true;
                    this.annotations.domPos.top =  this.annotations.domPos.top;
                } else if (value === "pinyin")  {
                    this.annotations["type"] =  "pinyin";
                    this.annotations["isHanPin"] = true;
                }  else if (value === "karaokeword" ) {
                    this.annotations["isKaraokeRow"] = true;
                    this.annotations["karaokegrouptag"] = String(builder.meta["karaokegrouptag"]);
                    this.annotations["rowindex"] = parseInt(builder.meta["rowindex"]);
                } else if (value === "showhide" ) {
                    this.annotations["type"] =  "toggleHints";
                    this.annotations["isToggleHints"] = true;
                } else if (value === "step") {
                    this.annotations["type"] =  "stepByStep";
                    this.annotations["isStepByStep"] = true;
                } else if (value === "gif") {
                    this.annotations["type"] = "gif";
                    this.annotations["isGif"] = true;
                }

                if (!this.annotationTypes.includes(this.annotations["type"])) {
                    this.annotationTypes.push( this.annotations["type"]);
                }

                hasLayer = true;

            } else if (key === "id") {
                super.setAnnotations({[key]:value});
                let imgSrc, grouptag, showAsDefault;

                for (let item of builder.toggleHintsIdMapping) {
                    if (item.targetRectId === value) {
                        imgSrc = item.imgSrc;
                        grouptag = String(item.grouptag);
                        showAsDefault = item.showAsDefault ? true : false
                        break;
                    }
                }

                if (grouptag) {
                    super.setAnnotations({"grouptag": grouptag});
                }

                if (imgSrc) {
                    super.setAnnotations({"imgSrc": imgSrc});
                } else {
                    this.annotations["redundant"] = true;
                }

                 super.setAnnotations({"showAsDefault": showAsDefault});

            } else if (key === "res") {
                super.setAnnotations({[key]:value});
                if (value.indexOf(".html")>=0 && value.indexOf("exercise")>=0) {
                    this.annotations["isInlineExercise"] = true;
                    this.annotations["redundant"] = false;
                    this.annotationTypes.push("inline-exercise");
                }
            }

        }


        //contentRect should normally contain layer value, but if really missing, it's considered show/hide type...
        if (!hasLayer) {
            this.annotations["type"] =  "toggleHints";
            this.annotations["isToggleHints"] = true;
            this.annotationTypes.push( this.annotations["type"]);
        }

    }

}

export default ContentRectAnnotation